// import { useEffect, useRef, useState } from 'react';
// import { Accordion, Collapse, Form } from 'react-bootstrap';
// import { FaChevronDown, FaChevronUp, FaDownload, FaFileUpload } from 'react-icons/fa';
// import { IoClose } from 'react-icons/io5';
// import { toast } from 'react-toastify';
// import { DeleteFileDreOrBalance, GetAllFiles, UploadFileAnalysis } from '../../../API/AnalysisAPI';
// import useModal from '../../../Hooks/useModal';
// import { IResponseProps } from '../../../Interfaces/IResponseProps';
// import { FileModel } from '../../../Models/FileModel';
// import ModalDelete from '../../Shared/ModalDelete';
// import './styles.css';
// import { AccordionSummary, Button, FormControl, FormLabel, Input } from '@mui/material';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// interface IFileProps {
//     fileName: string,
//     id: string
// }

// interface ICollapseUploadComponentProps {
//     companyId: string,
//     userEmail: string,
//     yearId: string,
//     typeOfFile: number,
//     yearName: string,
//     toggleLoading: (data: boolean) => void,
//     FINNCanNotView: boolean
// }

// const CollapseUploadComponent = (props: ICollapseUploadComponentProps) => {
//     const { showModal, toggleShowModal } = useModal();
//     const [open, setOpen] = useState(false);
//     const [file, setFile] = useState(null);
//     const [fileList, setFileList] = useState<FileModel[]>([]);
//     const [deleteFileState, setDeleteFileState] = useState(false);
//     const [fileTemp, setFileTemp] = useState<IFileProps>({ fileName: "", id: "" });
//     const path = `${props.companyId}/Master`;
//     const ref = useRef<HTMLInputElement>(null);

//     const sendFile = async () => {
//         try {
//             props.toggleLoading(true);

//             await UploadFileAnalysis(file, path, props.yearName, props.userEmail, props.companyId, props.typeOfFile, "master").then((resp: IResponseProps) => {
//                 if (resp.statusCode == 200) {
//                     toast.success("Upload feito com sucesso!");
//                     setFile(null);
//                     if (ref.current != null) {
//                         ref.current.value = "";
//                     }
//                     getAllFiles();
//                 }
//             }).finally(() => {
//                 props.toggleLoading(false);
//             });
//         } catch (error: any) {
//             toast.error(error);
//             props.toggleLoading(false);
//         }
//     }

//     const getAllFiles = async () => {
//         try {
//             await GetAllFiles(props.typeOfFile, props.companyId, props.yearName).then((resp: IResponseProps) => {
//                 if (resp.statusCode == 200) {
//                     setFileList(resp.data);
//                 }
//             });
//         } catch (error: any) {
//             toast.error(error);
//         }
//     }

//     const deleteFile = async (fileName: string, fileId: string) => {
//         try {
//             props.toggleLoading(true);
//             await DeleteFileDreOrBalance(props.yearName, encodeURIComponent(fileName), fileId, props.companyId).then((resp: IResponseProps) => {
//                 if (resp.statusCode == 200) {
//                     setDeleteFileState(false);
//                     getAllFiles();
//                 }
//             }).finally(() => props.toggleLoading(false));
//         } catch (error: any) {
//             props.toggleLoading(false);
//             toast.error(error.message);
//         }
//     }

//     useEffect(() => {
//         getAllFiles();
//     }, [props.yearId]);

//     useEffect(() => {
//         if (deleteFileState) {
//             deleteFile(fileTemp.fileName, fileTemp.id);
//         } else {
//             setFileTemp({ fileName: "", id: "" });
//         }
//     }, [deleteFileState]);

//     return (
//         <div className='mb-2 card'>
//             <ModalDelete
//                 show={showModal}
//                 toggleShow={toggleShowModal}
//                 setResponse={setDeleteFileState}
//             />
//             <Accordion className='card-header d-flex align-items-center justify-content-between cursor-pointer w-100' onClick={() => setOpen(!open)}>
//                 <AccordionSummary >
//                     <div className='d-flex align-items-center'>

//                         <span className='label-collap'>
//                             <b>{props.typeOfFile == 0 ? "Inserir DRE:" : "Inserir Balanço Patrimonial:"}</b>
//                         </span>

//                         {
//                             !props.FINNCanNotView &&
//                             <>
//                                 <FormControl className='mx-3' component="fieldset"><FormLabel component="legend"></FormLabel><Input  type="file" onChange={(e: any) => setFile(e.target.files[0] ? e.target.files[0] : null)} /></FormControl>

//                                 <Button variant="contained" onClick={() => sendFile()} className='btn btn-sm btn-primary button-upload' >
//                                     <FaFileUpload />
//                                     <span className='ms-2'>Upload</span>
//                                 </Button>
//                             </>
//                         }
//                     </div>
//                 </AccordionSummary>
//                 {open ?
//                     <FaChevronUp className="font-awesome-icon" />
//                     :
//                     <FaChevronDown className="font-awesome-icon" />
//                 }
//             </Accordion>
//             <Collapse in={open}>
//                 <div id="collapse" className='p-3'>
//                     <div className='d-flex flex-column align-items-start'>
//                         {fileList.length > 0 && fileList.map((file, index) => {
//                             return (
//                                 <div key={index} className={`${fileList.length > 1 && fileList.length != index + 1 && 'border-bottom pb-2'} mb-2 d-flex align-items-center justify-content-between w-100`}>
//                                     <a href={file.fileAzurePath} download={file.fileName} className="files-collapse">
//                                         <FaDownload className="font-awesome-icon me-2" />
//                                         <span>{file.fileName}</span>
//                                     </a>
//                                     {
//                                         !props.FINNCanNotView &&
//                                         <button
//                                             onClick={() => {
//                                                 setFileTemp({ fileName: file.fileName, id: file.id })
//                                                 toggleShowModal()
//                                             }}
//                                             className="button-remove"
//                                         >
//                                             <IoClose className="font-awesome-icon me-2" />
//                                         </button>
//                                     }
//                                 </div>

//                             )
//                         })}
//                     </div>
//                 </div>
//             </Collapse>
//         </div>
//     )
// }

// export default CollapseUploadComponent;


import { useEffect, useState } from "react";
import { Upload, Button, Modal, message } from "antd";
import { FileDoneOutlined, CloseOutlined, InboxOutlined } from "@ant-design/icons";
import { DeleteFileDreOrBalance, GetAllFiles, UploadFileAnalysis } from "../../../API/AnalysisAPI";
import ModalDelete from '../../Shared/ModalDelete';
import useModal from "../../../Hooks/useModal";
import { IResponseProps } from "../../../Interfaces/IResponseProps";
import { FileModel } from "../../../Models/FileModel";
import "./styles.css";
const { Dragger } = Upload;
interface IFileProps {
    fileName: string;
    id: string;
}
interface ICollapseUploadComponentProps {
    companyId: string;
    userEmail: string;
    yearId: string;
    typeOfFile: number;
    yearName: string;
    toggleLoading: (data: boolean) => void;
    FINNCanNotView: boolean;
}
const CollapseUploadComponent = (props: ICollapseUploadComponentProps) => {
    const { showModal, toggleShowModal } = useModal();
    const [fileList, setFileList] = useState<FileModel[]>([]);
    const [deleteFileState, setDeleteFileState] = useState(false);
    const [fileTemp, setFileTemp] = useState<IFileProps>({ fileName: "", id: "" });
    const path = `${props.companyId}/Master`;
    const sendFile = async (file: File) => {
        try {
            props.toggleLoading(true);
            const response: IResponseProps = await UploadFileAnalysis(
                file, path, props.yearName, props.userEmail, props.companyId, props.typeOfFile, "master"
            );
            if (response.statusCode === 200) {
                message.success("Upload feito com sucesso!");
                getAllFiles();
            }
        } catch (error: any) {
            message.error(error.message);
        } finally {
            props.toggleLoading(false);
        }
    };
    const getAllFiles = async () => {
        try {
            const response: IResponseProps = await GetAllFiles(props.typeOfFile, props.companyId, props.yearName);
            if (response.statusCode === 200) {
                setFileList(response.data);
            }
        } catch (error: any) {
            message.error(error.message);
        }
    };
    const deleteFile = async () => {
        if (!fileTemp.id) return;
        try {
            props.toggleLoading(true);
            const response: IResponseProps = await DeleteFileDreOrBalance(
                props.yearName, encodeURIComponent(fileTemp.fileName), fileTemp.id, props.companyId
            );
            if (response.statusCode === 200) {
                message.success("Arquivo deletado com sucesso!");
                setDeleteFileState(false);
                getAllFiles();
            }
        } catch (error: any) {
            message.error(error.message);
        } finally {
            props.toggleLoading(false);
        }
    };
    useEffect(() => {
        getAllFiles();
    }, [props.yearId]);
    useEffect(() => {
        if (deleteFileState) {
            deleteFile();
        }
    }, [deleteFileState]);
    return (
        <div className="upload-container">
             <ModalDelete
                 show={showModal}
                 toggleShow={toggleShowModal}
                 setResponse={setDeleteFileState}
             />
            <div className="upload-title">
                <b>{props.typeOfFile === 0 ? "Inserir DRE:" : "Inserir Balanço Patrimonial:"}</b>
            </div>
            <Dragger
                multiple
                showUploadList={false}
                beforeUpload={(file) => {
                    sendFile(file);
                    return false;
                }}
            >
                <div className="upload-content">
                    <p 
                        className="ant-upload-text"
                        style={{ fontFamily: 'Century Gothic, sans-serif', fontSize: '14px', color: '#bfbfbf', margin: '8px'}}
                    >
                        Selecione um arquivo...
                    </p>
                    <Button className="upload-button">Escolher um arquivo</Button>
                </div>
            </Dragger>
            {fileList.length > 0 && (
                <div className="file-list">
                    {fileList.map((file, index) => (
                        <div key={index} className="file-item">
                            <CloseOutlined
                                className="close-icon"
                                onClick={() => {
                                    setFileTemp({ fileName: file.fileName, id: file.id });
                                    toggleShowModal();
                                }}
                            />
                            <a href={file.fileAzurePath} download={file.fileName} className="file-download">
                                <FileDoneOutlined className="file-icon" />
                                <span className="file-name">{file.fileName}</span>
                            </a>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
export default CollapseUploadComponent;